import React from 'react';
import { Lightbulb, Smartphone, DollarSign } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    icon: <Lightbulb className="w-8 h-8 text-gaming-cyan" data-id="element-112" />,
    title: 'Optimización Base',
    desc: "Aplica la configuración de 'Iluminación de Guerrilla' y optimiza tu audio con lo que ya tienes."
  }, {
    num: '02',
    icon: <Smartphone className="w-8 h-8 text-gaming-cyan" data-id="element-113" />,
    title: 'Tráfico Externo',
    desc: 'Ejecuta el plan de contenido vertical en TikTok para atraer tus primeros 10 espectadores recurrentes.'
  }, {
    num: '03',
    icon: <DollarSign className="w-8 h-8 text-gaming-cyan" data-id="element-114" />,
    title: 'Monetización',
    desc: 'Implementa la estrategia de monetización híbrida para llegar a tus primeros $500 mensuales.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-gaming-bg relative" data-id="element-115">
      <div className="max-w-5xl mx-auto" data-id="element-116">
        <div className="text-center mb-20" data-id="element-117">
          <h2 className="font-orbitron text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-118">
            Cómo Funciona el{' '}
            <span className="text-gaming-cyan text-glow-cyan" data-id="element-119">Sistema</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-120">
            Un proceso lineal de 3 pasos diseñado para resultados rápidos.
          </p>
        </div>

        <div className="relative" data-id="element-121">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gradient-to-r from-gaming-bg via-gaming-cyan/30 to-gaming-bg -translate-y-1/2 z-0" data-id="element-122" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-123">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-124">
                <div className="w-20 h-20 rounded-2xl bg-gaming-card border border-gaming-cyan/40 flex items-center justify-center mb-6 box-glow-cyan group-hover:-translate-y-2 transition-transform duration-300 relative" data-id="element-125">
                  <div className="absolute -top-3 -right-3 bg-gaming-cyan text-gaming-bg font-orbitron font-bold text-sm w-8 h-8 rounded-full flex items-center justify-center" data-id="element-126">
                    {step.num}
                  </div>
                  {step.icon}
                </div>
                <h3 className="font-orbitron text-xl font-bold text-white mb-3" data-id="element-127">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-128">{step.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}